import { Button, FormControl, FormControlLabel, InputLabel, makeStyles, Radio, RadioGroup, Select, Snackbar, TextField, useMediaQuery } from '@material-ui/core';
import MuiAlert from '@material-ui/lab/Alert';
import React, { useState } from 'react';
import jsPDF from 'jspdf';

function NeonatalForm() {

    const mobile = useMediaQuery('(max-width: 500px)');
    const styles = useStyles({ mobile });

    const [name, setName] = useState('');
    const [age1, setAge1] = useState('');
    const [sex1, setSex1] = useState('Female');
    const [UHID, setUHID] = useState('');
    const [MRD, setMRD] = useState('');
    const [date, setDate] = useState('2021-05-16T10:30');
    const [so_do_wo, setSo_do_wo] = useState('');
    const [obstetricianIncharge, setObstetricianIncharge] = useState('');
    const [paediatricianIncharge, setPaediatricianIncharge] = useState('');
    const [dob, setDob] = useState('2021-05-16');
    const [modeOfDelivery, setModeOfDelivery] = useState('Vaginal');
    const [forceps_vaccum, setForceps_vaccum] = useState('No');
    const [tob, setTob] = useState('10:30');
    const [indicationLSCS, setIndicationLSCS] = useState('');
    const [sex2, setSex2] = useState('Female');
    const [EDD, setEDD] = useState('');
    const [gestation, setGestation] = useState('');
    const [wks, setWks] = useState('');
    const [birthWeight, setBirthWeight] = useState('');
    const [APGAR, setAPGAR] = useState(`1'`);
    const [resuscitationDetail, setResuscitationDetail] = useState('');

    // Examination of Newborn
    const [gestationBorn, setGestationBorn] = useState('');
    const [weight, setWeight] = useState('');
    const [length, setLength] = useState('');
    const [headCircum, setHeadCircum] = useState('');
    const [vitalHR, setVitalHR] = useState('');
    const [RR, setRR] = useState('');
    const [BP, setBP] = useState('');
    const [spo2, setSpo2] = useState('');
    const [color, setColor] = useState('');
    const [PP, setPP] = useState('');
    const [AF, setAF] = useState('');
    const [pupils, setPupils] = useState('');

    //Gross Abnormalities (Head to Toe)
    const [cryActivity, setCryActivity] = useState('');
    const [reflexes, setReflexes] = useState('');
    const [startle, setStartle] = useState('');
    const [rootingSucking, setRootingSucking] = useState('');
    const [moro, setMoro] = useState('');
    const [abdomenUmblicus, setAbdomenUmblicus] = useState('');
    const [chest, setChest] = useState('');
    const [CVS, setCVS] = useState('');
    const [femoralPulse, setFemoralPulse] = useState('');
    const [CDH, setCDH] = useState('');
    const [hernialSites, setHernialSites] = useState('');
    const [genitalia, setGenitalia] = useState('');
    const [orifices, setOrifices] = useState('');
    const [redReflex, setRedReflex] = useState('');
    const [anyMalformation, setAnyMalformation] = useState('');

    //Maternal History
    const [age2, setAge2] = useState('');
    const [gravidityParity, setGravidityParity] = useState('');
    const [liveHealthyChildren, setLiveHealthyChildren] = useState('');
    const [medicalHistory, setMedicalHistory] = useState('');

    //Details of Present Pregnancy
    const [bloodGroup, setBloodGroup] = useState('');
    const [hb, setHb] = useState('');
    const [HIV, setHIV] = useState('-ve');
    const [hepatities, setHepatities] = useState('-ve');
    const [VDRL, setVDRL] = useState('-ve');
    const [usgAntenatalNst, setUsgAntenatalNst] = useState('');
    const [otherInvestigation, setOtherInvestigation] = useState('');
    const [backgroundInfection, setBackgroundInfection] = useState('');
    const [hoLeaking, setHoLeaking] = useState('');
    const [foulSmellingLiquor, setFoulSmellingLiquor] = useState('');
    const [soInfectionMother, setSoInfectionMother] = useState('');

    //Any s/o fetal distress
    const [meconium, setMeconium] = useState('No');
    const [drugHistory, setDrugHistory] = useState('');
    const [other, setOther] = useState('');
    const [impression, setImpression] = useState('');

    const [sign, setSign] = useState('');

    const [open, setOpen] = useState(false);

    function Alert(props) {
        return <MuiAlert elevation={6} variant="filled" {...props} />;
    }

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpen(false);
    };

    const handleReset = () => {
        //Reset Input fields
        setName('');
        setAge1('');
        setSex1('Female');
        setUHID('');
        setMRD('');
        setDate('2021-05-16T10:30');
        setSo_do_wo('');
        setObstetricianIncharge('');
        setPaediatricianIncharge('');
        setDob('2021-05-16');
        setModeOfDelivery('Vaginal');
        setForceps_vaccum('No');
        setTob('10:30');
        setIndicationLSCS('');
        setSex2('Female');
        setEDD('');
        setGestation('');
        setWks('');
        setBirthWeight('');
        setAPGAR(`1'`);
        setResuscitationDetail('');
        setGestationBorn('');
        setWeight('');
        setLength('');
        setHeadCircum('');
        setVitalHR('');
        setRR('');
        setBP('');
        setSpo2('');
        setColor('');
        setPP('');
        setAF('');
        setPupils('');
        setCryActivity('');
        setReflexes('');
        setStartle('');
        setRootingSucking('');
        setMoro('');
        setAbdomenUmblicus('');
        setChest('');
        setCVS('');
        setFemoralPulse('');
        setCDH('');
        setHernialSites('');
        setGenitalia('');
        setOrifices('');
        setRedReflex('');
        setAnyMalformation('');
        setAge2('');
        setGravidityParity('');
        setLiveHealthyChildren('');
        setMedicalHistory('');
        setBloodGroup('');
        setHb('');
        setHIV('-ve');
        setHepatities('-ve');
        setVDRL('-ve');
        setUsgAntenatalNst('');
        setOtherInvestigation('');
        setBackgroundInfection('');
        setHoLeaking('');
        setFoulSmellingLiquor('');
        setSoInfectionMother('');
        setMeconium('Yes');
        setDrugHistory('');
        setOther('');
        setImpression('');
        setSign('');

    }

    const pdfGenerator = () => {
        var doc = new jsPDF('p', 'pt', 'a4');
        doc.setFontSize(14);

        doc.text("EVA Healthcare", 290, 40, 'center');
        doc.text("NEONATAL ASSESSMENT SHEET", 290, 60, 'center');

        doc.setFontSize(12);
        doc.text(`Name: ${name}`, 40, 100);
        doc.text(`Age: ${age1}`, 230, 100);
        doc.text(`Sex: ${sex1}`, 400, 100);

        doc.text(`UHID No: ${UHID}`, 40, 125);
        doc.text(`M.R.D. No: ${MRD}`, 230, 125);
        doc.text(`Date & Time: ${date}`, 400, 125);

        doc.text(`S/o, D/o, W/o: ${so_do_wo}`, 40, 150);

        doc.text(`Obstetrician Incharge: ${obstetricianIncharge}`, 40, 175);
        doc.text(`Paediatrician Incharge: ${paediatricianIncharge}`, 330, 175);

        doc.text(`Date of Birth: ${dob}`, 40, 200);
        doc.text(`Mode of delivery: ${modeOfDelivery}`, 330, 200);

        doc.text(`Forceps / Vaccum: ${forceps_vaccum}`, 330, 225);

        doc.text(`Time of Birth: ${tob}`, 40, 250);
        doc.text(`Indication of LSCS: ${indicationLSCS}`, 330, 250);

        doc.text(`Sex: ${sex2}`, 40, 275);
        doc.text(`EDD: ${EDD}`, 250, 275);
        doc.text(`Gestation: ${gestation}`, 350, 275);
        doc.text(`Wks: ${wks}`, 450, 275);

        doc.text(`Birth Weight: ${birthWeight}`, 40, 300);

        doc.text(`APGAR (1', 5', 10'): ${APGAR}`, 40, 325);

        doc.text('Resuscitation detail / Post - Natal History:', 40, 350);
        doc.text(`${resuscitationDetail}`, 40, 375);

        doc.text('Examination of Newborn', 40, 450);
        doc.text(`Gestation: ${gestationBorn}`, 40, 475);
        doc.text(`Weight: ${weight}`, 250, 475);
        doc.text(`Length: ${length}`, 350, 475);
        doc.text(`Head Circum: ${headCircum}`, 450, 475);

        doc.text(`Vital HR: ${vitalHR}`, 40, 500);
        doc.text(`RR: ${RR}`, 250, 500);
        doc.text(`BP: ${BP}`, 350, 500);
        doc.text(`SpO2: ${spo2}`, 450, 500);

        doc.text(`Color: ${color}`, 40, 525);
        doc.text(`PP: ${PP}`, 250, 525);
        doc.text(`AF: ${AF}`, 350, 525);
        doc.text(`Pupils: ${pupils}`, 450, 525);

        doc.text('Gross Abnormalities (Head to Toe)', 40, 550);
        doc.text(`Cry/Activity: ${cryActivity}`, 250, 575);

        doc.text(`Reflexes: ${reflexes}`, 40, 600);
        doc.text(`Startle: ${startle}`, 200, 600);
        doc.text(`Rooting/Sucking: ${rootingSucking}`, 300, 600);
        doc.text(`Moro's: ${moro}`, 450, 600);

        doc.text(`Abdomen / Umblicus: ${abdomenUmblicus}`, 40, 650);
        doc.text(`Chest: ${chest}`, 40, 675);
        doc.text(`CVS: ${CVS}`, 40, 700);

        doc.text(`Femoral Pulse: ${femoralPulse}`, 40, 725);
        doc.text(`CDH: ${CDH}`, 250, 725);
        doc.text(`Hernial Sites: ${hernialSites}`, 370, 725);

        doc.text(`Genitalia: ${genitalia}`, 40, 750);
        doc.text(`Orifices: ${orifices}`, 250, 750);
        doc.text(`Red Reflex: ${redReflex}`, 370, 750);

        doc.text(`Any congential malfromation: ${anyMalformation}`, 40, 775);


        doc.addPage('a4');

        doc.text('Maternal History', 40, 50);
        doc.text(`Age: ${age2}`, 40, 75);
        doc.text(`Gravidity and Parity: ${gravidityParity}`, 150, 75);
        doc.text(`Live and Healthy children: ${liveHealthyChildren}`, 350, 75);

        doc.text('Any medical history / Family History / Details of previous pregnancies', 40, 100);
        doc.text(`${medicalHistory}`, 40, 125);

        doc.text('Details of Present Pregnancy', 40, 175);
        doc.text(`Blood Group: ${bloodGroup}`, 40, 200);
        doc.text(`Hb: ${hb}`, 200, 200);
        doc.text(`HIV: ${HIV}`, 250, 200);
        doc.text(`Hepatitis: ${hepatities}`, 320, 200);
        doc.text(`VDRL: ${VDRL}`, 420, 200);

        doc.text(`USG / Antenatal Doplpler / NST: ${usgAntenatalNst}`, 40, 225);
        doc.text(`Other Relevant Investigation: ${otherInvestigation}`, 40, 250);
        doc.text(`Background of Infection: ${backgroundInfection}`, 40, 275);

        doc.text(`H/o leaking: ${hoLeaking}`, 40, 300);
        doc.text(`Foul smelling liquor: ${foulSmellingLiquor}`, 200, 300);
        doc.text(`S/o infection in mother: ${soInfectionMother}`, 350, 300);

        doc.text('Any s/o fetal distress', 40, 350);
        doc.text(`Meconium: ${meconium}`, 40, 375);
        doc.text(`Drug History: ${drugHistory}`, 200, 375);

        doc.text(`Other: ${other}`, 40, 400);

        doc.text(`Impression: ${impression}`, 40, 425);

        doc.text('Advice:', 40, 450);
        doc.text('1. Transfer to Mother / Nursery / NICU', 60, 475);
        doc.text('2. Inj. Vitamin K 0.5mg/1mg given', 60, 500);
        doc.text('3. Watch for cord bleeding / discharge', 60, 525);
        doc.text('4. Feeding advice', 60, 550);
        doc.text('5. Others', 60, 575);

        doc.save(`${name}${date}`);
        setOpen(true);
    }


    return (
        <div className={styles.neonatalContainer}>
            <div className={styles.mainHeading}>EVA Healthcare</div>
            <div className={styles.heading}>Neonatal Assessment Sheet</div>
            <TextField
                onChange={(e) => setName(e.target.value)}
                variant="outlined"
                label="Name"
                margin="dense"
                fullWidth
                value={name}
                className={styles.input}
            />
            <TextField
                onChange={(e) => setAge1(e.target.value)}
                variant="outlined"
                label="Age"
                margin="dense"
                value={age1}
                className={styles.inputManual}
            />
            {/* <label>Sex</label> */}
            <RadioGroup aria-label="gender" name="gender1" value={sex1}
                onChange={(e) => setSex1(e.target.value)}>
                <FormControlLabel value="Female" control={<Radio />} label="Female" />
                <FormControlLabel value="Male" control={<Radio />} label="Male" />
                {/* <FormControlLabel value="other" control={<Radio />} label="Other" /> */}
            </RadioGroup>
            <TextField
                onChange={(e) => setUHID(e.target.value)}
                variant="outlined"
                label="UHID Number"
                margin="dense"
                fullWidth
                value={UHID}
                className={styles.input}
            />
            <TextField
                onChange={(e) => setMRD(e.target.value)}
                variant="outlined"
                label="M.R.D Number"
                margin="dense"
                fullWidth
                value={MRD}
                className={styles.input}
            />
            <TextField
                onChange={(e) => setDate(e.target.value)}
                variant="outlined"
                margin="dense"
                fullWidth
                label="Date and Time"
                type="datetime-local"
                defaultValue="2021-05-16T10:30"
                InputLabelProps={{
                    shrink: true,
                }}
                value={date}
            />
            <TextField
                onChange={(e) => setSo_do_wo(e.target.value)}
                variant="outlined"
                label="S/o, D/o, W/o"
                margin="dense"
                fullWidth
                value={so_do_wo}
                className={styles.input}
            />
            <TextField
                onChange={(e) => setObstetricianIncharge(e.target.value)}
                variant="outlined"
                label="Obstetrician Incharge"
                margin="dense"
                fullWidth
                value={obstetricianIncharge}
                className={styles.input}
            />
            <TextField
                onChange={(e) => setPaediatricianIncharge(e.target.value)}
                variant="outlined"
                label="Paediatrician Incharge"
                margin="dense"
                fullWidth
                value={paediatricianIncharge}
                className={styles.input}
            />
            <TextField
                onChange={(e) => setDob(e.target.value)}
                variant="outlined"
                label="Date of Birth"
                margin="dense"
                type="date"
                fullWidth
                defaultValue="2021-05-16"
                value={dob}
                className={styles.input}
            />

            <FormControl variant="outlined" fullWidth margin="dense">
                <InputLabel htmlFor="outlined-age-native-simple">Mode of Delivery</InputLabel>
                <Select
                    native
                    value={modeOfDelivery}
                    onChange={(e) => setModeOfDelivery(e.target.value)}
                    label="Mode of Delivery"
                >
                    <option value="Vaginal">Vaginal</option>
                    <option value="LSCS">LSCS</option>
                </Select>
            </FormControl>

            <FormControl variant="outlined" fullWidth margin="dense">
                <InputLabel htmlFor="outlined-age-native-simple">Forceps / Vaccum</InputLabel>
                <Select
                    native
                    value={forceps_vaccum}
                    onChange={(e) => setForceps_vaccum(e.target.value)}
                    label="Forceps / Vaccum"
                >
                    <option value="Yes">Yes</option>
                    <option value="No">No</option>
                </Select>
            </FormControl>
            <TextField
                onChange={(e) => setTob(e.target.value)}
                variant="outlined"
                label="Time of Birth"
                margin="dense"
                fullWidth
                value={tob}
                className={styles.input}
                type="time"
                defaultValue="10:30"
            />
            <TextField
                onChange={(e) => setIndicationLSCS(e.target.value)}
                variant="outlined"
                label="Indication if LSCS"
                margin="dense"
                fullWidth
                value={indicationLSCS}
                className={styles.input}
            />
            <RadioGroup aria-label="gender" name="gender1" value={sex2}
                onChange={(e) => setSex2(e.target.value)}>
                <FormControlLabel value="Female" control={<Radio />} label="Female" />
                <FormControlLabel value="Male" control={<Radio />} label="Male" />
                {/* <FormControlLabel value="other" control={<Radio />} label="Other" /> */}
            </RadioGroup>
            <TextField
                onChange={(e) => setEDD(e.target.value)}
                variant="outlined"
                label="EDD"
                margin="dense"
                fullWidth
                value={EDD}
                className={styles.input}
            />
            <TextField
                onChange={(e) => setGestation(e.target.value)}
                variant="outlined"
                label="Gestation"
                margin="dense"
                fullWidth
                value={gestation}
                className={styles.input}
            />
            <TextField
                onChange={(e) => setWks(e.target.value)}
                variant="outlined"
                label="Wks"
                margin="dense"
                fullWidth
                value={wks}
                className={styles.input}
            />
            <TextField
                onChange={(e) => setBirthWeight(e.target.value)}
                variant="outlined"
                label="Birth Weight"
                margin="dense"
                fullWidth
                value={birthWeight}
                className={styles.input}
            />

            <FormControl variant="outlined" fullWidth margin="dense">
                <InputLabel htmlFor="outlined-age-native-simple">APGAR</InputLabel>
                <Select
                    native
                    value={APGAR}
                    onChange={(e) => setAPGAR(e.target.value)}
                    label="APGAR"
                >
                    <option value="1'">1'</option>
                    <option value="5'">5'</option>
                    <option value="10'">10'</option>
                </Select>
            </FormControl>

            {/* <div className={styles.heading}>Resuscitation-detail/Post-Natal History</div> */}
            <TextField
                onChange={(e) => setResuscitationDetail(e.target.value)}
                variant="outlined"
                label="Resuscitation-detail/Post-Natal History"
                margin="dense"
                fullWidth
                value={resuscitationDetail}
                className={styles.input}
                multiline
                rowsMax={4}
            />

            <div className={styles.heading}>Examination of Newborn</div>
            <TextField
                onChange={(e) => setGestationBorn(e.target.value)}
                variant="outlined"
                label="Gestation"
                margin="dense"
                fullWidth
                value={gestationBorn}
                className={styles.input}
            />
            <TextField
                onChange={(e) => setWeight(e.target.value)}
                variant="outlined"
                label="Weight"
                margin="dense"
                fullWidth
                value={weight}
                className={styles.input}
            />
            <TextField
                onChange={(e) => setLength(e.target.value)}
                variant="outlined"
                label="Length"
                margin="dense"
                fullWidth
                value={length}
                className={styles.input}
            />
            <TextField
                onChange={(e) => setHeadCircum(e.target.value)}
                variant="outlined"
                label="Head Circum"
                margin="dense"
                fullWidth
                value={headCircum}
                className={styles.input}
            />
            <TextField
                onChange={(e) => setVitalHR(e.target.value)}
                variant="outlined"
                label="Vital HR"
                margin="dense"
                fullWidth
                value={vitalHR}
                className={styles.input}
            />
            <TextField
                onChange={(e) => setRR(e.target.value)}
                variant="outlined"
                label="RR"
                margin="dense"
                fullWidth
                value={RR}
                className={styles.input}
            />
            <TextField
                onChange={(e) => setBP(e.target.value)}
                variant="outlined"
                label="BP"
                margin="dense"
                fullWidth
                value={BP}
                className={styles.input}
            />
            <TextField
                onChange={(e) => setSpo2(e.target.value)}
                variant="outlined"
                label="SpO2"
                margin="dense"
                fullWidth
                value={spo2}
                className={styles.input}
            />
            <TextField
                onChange={(e) => setColor(e.target.value)}
                variant="outlined"
                label="Color"
                margin="dense"
                fullWidth
                value={color}
                className={styles.input}
            />
            <TextField
                onChange={(e) => setPP(e.target.value)}
                variant="outlined"
                label="PP"
                margin="dense"
                fullWidth
                value={PP}
                className={styles.input}
            />
            <TextField
                onChange={(e) => setAF(e.target.value)}
                variant="outlined"
                label="AF"
                margin="dense"
                fullWidth
                value={AF}
                className={styles.input}
            />
            <TextField
                onChange={(e) => setPupils(e.target.value)}
                variant="outlined"
                label="Pupils"
                margin="dense"
                fullWidth
                value={pupils}
                className={styles.input}
            />

            <div className={styles.heading}>Gross Abnormalities (Head to Toe)</div>
            <TextField
                onChange={(e) => setCryActivity(e.target.value)}
                variant="outlined"
                label="Cry/Activity"
                margin="dense"
                fullWidth
                value={cryActivity}
                className={styles.input}
            />
            <TextField
                onChange={(e) => setReflexes(e.target.value)}
                variant="outlined"
                label="Reflexes"
                margin="dense"
                fullWidth
                value={reflexes}
                className={styles.input}
            />
            <TextField
                onChange={(e) => setStartle(e.target.value)}
                variant="outlined"
                label="Startle"
                margin="dense"
                fullWidth
                value={startle}
                className={styles.input}
            />
            <TextField
                onChange={(e) => setRootingSucking(e.target.value)}
                variant="outlined"
                label="Rooting/Sucking"
                margin="dense"
                fullWidth
                value={rootingSucking}
                className={styles.input}
            />
            <TextField
                onChange={(e) => setMoro(e.target.value)}
                variant="outlined"
                label="Moro's"
                margin="dense"
                fullWidth
                value={moro}
                className={styles.input}
            />
            <TextField
                onChange={(e) => setAbdomenUmblicus(e.target.value)}
                variant="outlined"
                label="Abdomen/Umblicus"
                margin="dense"
                fullWidth
                value={abdomenUmblicus}
                className={styles.input}
            />
            <TextField
                onChange={(e) => setChest(e.target.value)}
                variant="outlined"
                label="Chest"
                margin="dense"
                fullWidth
                value={chest}
                className={styles.input}
            />
            <TextField
                onChange={(e) => setCVS(e.target.value)}
                variant="outlined"
                label="CVS"
                margin="dense"
                fullWidth
                value={CVS}
                className={styles.input}
            />
            <TextField
                onChange={(e) => setFemoralPulse(e.target.value)}
                variant="outlined"
                label="Femoral Pulse"
                margin="dense"
                fullWidth
                value={femoralPulse}
                className={styles.input}
            />
            <TextField
                onChange={(e) => setCDH(e.target.value)}
                variant="outlined"
                label="CDH"
                margin="dense"
                fullWidth
                value={CDH}
                className={styles.input}
            />
            <TextField
                onChange={(e) => setHernialSites(e.target.value)}
                variant="outlined"
                label="Hernial Sites"
                margin="dense"
                fullWidth
                value={hernialSites}
                className={styles.input}
            />
            <TextField
                onChange={(e) => setGenitalia(e.target.value)}
                variant="outlined"
                label="Genitalia"
                margin="dense"
                fullWidth
                value={genitalia}
                className={styles.input}
            />
            <TextField
                onChange={(e) => setOrifices(e.target.value)}
                variant="outlined"
                label="Orifices"
                margin="dense"
                fullWidth
                value={orifices}
                className={styles.input}
            />
            <TextField
                onChange={(e) => setRedReflex(e.target.value)}
                variant="outlined"
                label="Red Reflex"
                margin="dense"
                fullWidth
                value={redReflex}
                className={styles.input}
            />
            <TextField
                onChange={(e) => setAnyMalformation(e.target.value)}
                variant="outlined"
                label="Any congenital malformation"
                margin="dense"
                fullWidth
                value={anyMalformation}
                className={styles.input}
            />

            <div className={styles.heading}>Maternal History</div>
            <TextField
                onChange={(e) => setAge2(e.target.value)}
                variant="outlined"
                label="Age"
                margin="dense"
                fullWidth
                value={age2}
                className={styles.input}
            />
            <TextField
                onChange={(e) => setGravidityParity(e.target.value)}
                variant="outlined"
                label="Gravidity and Parity"
                margin="dense"
                fullWidth
                value={gravidityParity}
                className={styles.input}
            />
            <TextField
                onChange={(e) => setLiveHealthyChildren(e.target.value)}
                variant="outlined"
                label="Live and Healthy children"
                margin="dense"
                fullWidth
                value={liveHealthyChildren}
                className={styles.input}
            />
            <TextField
                onChange={(e) => setMedicalHistory(e.target.value)}
                variant="outlined"
                label="Any medical history / Family history / Details of previous pregnancies"
                // margin=""
                fullWidth
                value={medicalHistory}
                className={styles.input}
                multiline
                rowsMax={4}
            />

            <div className={styles.heading}>Details of Present Pregnancy</div>
            <TextField
                onChange={(e) => setBloodGroup(e.target.value)}
                variant="outlined"
                label="Blood Group"
                margin="dense"
                fullWidth
                value={bloodGroup}
                className={styles.input}
            />
            <TextField
                onChange={(e) => setHb(e.target.value)}
                variant="outlined"
                label="Hb"
                margin="dense"
                fullWidth
                value={hb}
                className={styles.input}
            />
            <FormControl variant="outlined" fullWidth margin="dense">
                <InputLabel htmlFor="outlined-age-native-simple">HIV</InputLabel>
                <Select
                    native
                    onChange={(e) => setHIV(e.target.value)}
                    value={HIV}
                    label="HIV"
                >
                    <option value="-ve">-ve</option>
                    <option value="+ve">+ve</option>
                </Select>
            </FormControl>
            <FormControl variant="outlined" fullWidth margin="dense">
                <InputLabel htmlFor="outlined-age-native-simple">Hepatitis</InputLabel>
                <Select
                    native
                    onChange={(e) => setHepatities(e.target.value)}
                    value={hepatities}
                    label="Hepatitis"
                >
                    <option value="-ve">-ve</option>
                    <option value="+ve">+ve</option>
                </Select>
            </FormControl>
            <FormControl variant="outlined" fullWidth margin="dense">
                <InputLabel htmlFor="outlined-age-native-simple">VDRL</InputLabel>
                <Select
                    native
                    onChange={(e) => setVDRL(e.target.value)}
                    value={VDRL}
                    label="VDRL"
                >
                    <option value="-ve">-ve</option>
                    <option value="+ve">+ve</option>
                </Select>
            </FormControl>
            <TextField
                onChange={(e) => setUsgAntenatalNst(e.target.value)}
                variant="outlined"
                label="USG / Antenatal Doppler / NST"
                margin="dense"
                fullWidth
                value={usgAntenatalNst}
                className={styles.input}
            />

            <TextField
                onChange={(e) => setOtherInvestigation(e.target.value)}
                variant="outlined"
                label="Other Relevant Investigation"
                margin="dense"
                fullWidth
                value={otherInvestigation}
                className={styles.input}
            />

            <TextField
                onChange={(e) => setBackgroundInfection(e.target.value)}
                variant="outlined"
                label="Background of Infection"
                margin="dense"
                fullWidth
                value={backgroundInfection}
                className={styles.input}
            />

            <TextField
                onChange={(e) => setHoLeaking(e.target.value)}
                variant="outlined"
                label="H/o leaking"
                margin="dense"
                fullWidth
                value={hoLeaking}
                className={styles.input}
            />

            <TextField
                onChange={(e) => setFoulSmellingLiquor(e.target.value)}
                variant="outlined"
                label="Foul smelling liquor"
                margin="dense"
                fullWidth
                value={foulSmellingLiquor}
                className={styles.input}
            />

            <TextField
                onChange={(e) => setSoInfectionMother(e.target.value)}
                variant="outlined"
                label="s/o infection in mother"
                margin="dense"
                fullWidth
                value={soInfectionMother}
                className={styles.input}
            />

            <div className={styles.heading}>Any s/o fetal distress</div>
            <FormControl variant="outlined" fullWidth margin="dense">
                <InputLabel htmlFor="outlined-age-native-simple">Meconium</InputLabel>
                <Select
                    native
                    onChange={(e) => setMeconium(e.target.value)}
                    value={meconium}
                    label="Meconium"
                >
                    <option value="Yes">Yes</option>
                    <option value="No">No</option>
                </Select>
            </FormControl>
            <TextField
                onChange={(e) => setDrugHistory(e.target.value)}
                variant="outlined"
                label="Drug History"
                margin="dense"
                fullWidth
                value={drugHistory}
                className={styles.input}
            />
            <TextField
                onChange={(e) => setOther(e.target.value)}
                variant="outlined"
                label="Other"
                margin="dense"
                fullWidth
                value={other}
                className={styles.input}
            />
            <TextField
                onChange={(e) => setImpression(e.target.value)}
                // variant="outlined"
                label="Impression"
                margin="dense"
                fullWidth
                value={impression}
                className={styles.input}
            />
            <TextField
                onChange={(e) => setSign(e.target.value)}
                // variant="outlined"
                label="Signature of attending paediatrician"
                margin="dense"
                fullWidth
                value={sign}
                className={styles.input}
            />

            <Button
                className={styles.button}
                onClick={pdfGenerator}
                variant="contained"
                color="primary"
                fullWidth
                style={{
                    marginTop: "10px"
                }}
            >
                Generate PDF
            </Button>
            <Button
                className={styles.resetButton}
                onClick={handleReset}
                variant="contained"
                color="primary"
                fullWidth
                style={{
                    marginTop: "10px"
                }}
            >
                Reset
            </Button>
            <Snackbar open={open} autoHideDuration={3000} onClose={handleClose}>
                <Alert onClose={handleClose} severity="success">
                    Pdf downloaded successfully.
                </Alert>
            </Snackbar>

        </div>
    )
}

export default NeonatalForm

const useStyles = makeStyles(({
    neonatalContainer: ({ mobile }) => mobile ? {
        margin: '10px',
        // display: 'flex',
        // flexDirection: 'column',
        // justifyContent: 'center',
        // border: '2px solid black',
        padding: '10px',
        marginTop: '50px'
    } : {
        margin: '50px',
    },
    inputManual: {
        width: '30%'
    },
    mainHeading: {
        textAlign: 'center',
        fontSize: '18px',
        marginBottom: '20px'
    },
    heading: {
        margin: '10px 0'
    }
    // resetButton: {
    //     backgroundColor: 'red',
    //     color: 'white'
    // }
    // button: {
    //     margin: '10px'
    // }
}))
